import { app } from '../../../../app';

app.service('StartLicensePayment', modal);

/** @ngInject */
function modal($uibModal) {
    return (tier, price, seats, email, totalPrice) => {
        return $uibModal.open({
            component: 'licenseManagementStartLicensePayment',
            resolve: {
                tier: () => tier,
                price: () => price,
                seats: () => seats,
                email: () => email,
                totalPrice: () => totalPrice,
            },
        }).result;
    };
}



// WEBPACK FOOTER //
// ./src/portal/states/company/license-management/start-payment/start-license-payment.modal.js